import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectsComponent implements OnInit {
  project:{type: string};
  
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.project = {type:this.route.snapshot.params['type']};
  }

  projects = [
    {
      id:"0",
      image: "./assets/images/blog-1.jpg",
      name:"Project 1",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing"
    },
    {
      id:"1",
      image: "./assets/images/blog-2.jpg",
      name:"Project 2",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"completed"
    },
    {
      id:"2",
      image: "./assets/images/blog-3.jpg",
      name:"Project 3",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing"
    },
    {
      id:"3",
      image: "./assets/images/blog-1.jpg",
      name:"Project 4",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"completed"
    },
    {
      id:"4",
      image: "./assets/images/blog-2.jpg",
      name:"Project 5",
      startDate:"25 July 2019",
      estimatedCompletionDate:"25 Aug 2019",
      completionDate:"20 Aug 2019",
      location:"Trimurti Nagar, Nagpur",
      shortDesc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text 1500s, when an unknown printer took a galley of type and scrambled Lorem Ipsum....",
      about:"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      type:"ongoing"
    }
  ];  
}
